// Single source of truth for the app version shown in the UI.
// Update this string to release a new version, then rebuild.
export const APP_VERSION = "1.0.0.55";

// Channel reported to the server (X-App-Channel) so the version gate can pick
// the right minimum-version key (web vs desktop).
export const APP_CHANNEL = "WEB";
